import * as React from 'react';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { MATCH_LIST_BEM as bem } from '../utils/match-list.constants';
import { compose } from 'redux';
import OutcomeList from './outcome-list';
import MatchListSelector from '../match-list-selector';
import { FilteredMarketGroupsOverview } from '../utils/match-list-models';
import { PlatformTypes } from '@om-fe/utils';

export interface MarketsHeaderPublicProps {
    readonly filteredMainMarketsList: string[];
    readonly showMarketsName?: boolean;
    readonly title?: React.ReactNode;
    readonly sliceKey: string;
    readonly groupOverview?: string;
    readonly selectGroupsOverview?: (item: string) => void;
    readonly filteredMarketGroupsOverviewList?: string[];
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly isHasDrawer?: boolean;
    readonly deviceType?: PlatformTypes;
    readonly mainMarketsLimit: number;
}

export type MarketsHeaderProps = MarketsHeaderPublicProps
    & I18nContextInterface;

class MarketsHeaderComponent extends React.PureComponent<MarketsHeaderProps> {
    getTitleNode(): React.ReactNode {
        const { gettext, title } = this.props;

        return title || gettext('Events');
    }

    selectGroupItem = (item: string): void => {
        const { selectGroupsOverview } = this.props;

        if (!selectGroupsOverview) {
            return;
        }
        selectGroupsOverview(item);
    };

    outcomesContent(): React.ReactNode {
        const { 
            filteredMainMarketsList,
            sliceKey,
            deviceType,
            isHasDrawer,
            filteredMarketGroupsOverview,
            filteredMarketGroupsOverviewList,
            groupOverview,
            mainMarketsLimit,
        } = this.props;
        
        if (filteredMarketGroupsOverviewList) {
            const children: React.ReactNode = <MatchListSelector
                selectGroupsOverview={this.selectGroupItem}
                filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                marketSelected={groupOverview ? groupOverview : ''}
                mainMarketsLimit={mainMarketsLimit}
                isHasDrawer={isHasDrawer}
                deviceType={deviceType}
            />

            return filteredMainMarketsList.map((mainMarketId: string,index: number) => (
                index !== filteredMainMarketsList.length - 1 
                ? <OutcomeList key={mainMarketId} mainMarketId={mainMarketId} sliceKey={sliceKey} />
                : <OutcomeList key={mainMarketId} mainMarketId={mainMarketId} sliceKey={sliceKey} children={children} />
            ))
        }

        return filteredMainMarketsList.map((mainMarketId: string) => (
            <OutcomeList key={mainMarketId} mainMarketId={mainMarketId} sliceKey={sliceKey}/>
        ))
    }

    render(): React.ReactNode {
        const { filteredMainMarketsList, showMarketsName, sliceKey } = this.props;

        if (!filteredMainMarketsList || !showMarketsName) {
            return null;
        }

        return (
            <div className={bem('Header')}>
                <span className={bem('Title')}>
                    {this.getTitleNode()}
                </span>
                <div className={bem('OutcomesList')}>
                    {this.outcomesContent()}
                </div>
            </div>
        );
    }
}

const MarketsHeader: React.ComponentType<MarketsHeaderPublicProps> = compose<React.ComponentType<MarketsHeaderPublicProps>>(
    withTranslation<MarketsHeaderPublicProps>(),
)(MarketsHeaderComponent);
export default MarketsHeader;
